import { Children, ReactNode } from "react";

export function getNonNullChildCount(children: ReactNode): number {
  return Children.toArray(children).filter((child) => child != null).length;
}
